<template>
  <div class="p-8 hidden md:block w-full">
    <h3
      v-if="input.heading"
      :class="['leading-none text-base', {
        'text-negative-600': error.length,
      }]"
    >
      {{ input.heading }}
    </h3>
    <small v-if="input.instructions" class="font-sm mt-2 block italic">
      {{ input.instructions }}
    </small>
    <div
      class="flex overflow-hidden"
      :style="{
        minHeight: (48 / 16) * 3 + 'rem'
      }"
    >
      <div
        v-for="({ label, key, value }, i) in categoriesWithValues"
        :key="label"
        class="flex-0 border-grey-600 border-dotted pb-8 overflow-hidden transition-all ease-in-out duration-150"
        :class="{
          'border-r': i != categoriesWithValues.length - 1 && value > 0
        }"
        :style="{
          width: (value || 0) + '%',
          paddingTop: (i + 1) * 2 + 'rem'
        }"
      >
        <label
          :for="key"
          class="text-white text-2xs uppercase tracking-wide font-bold whitespace-no-wrap py-1 cursor-pointer block overflow-hidden"
          :title="label"
          :class="{
            'bg-primary-500': !isOver100 && !isUnder100,
            'bg-negative-500': isOver100 || error.length,
            'bg-neutral-500': isUnder100 && !error.length,
            'rounded-l-full': i == 0,
            'rounded-r-full': i == categoriesWithValues.length - 1
          }"
        >
          <span v-if="value > 0" class="px-2">
            {{ value }}% - {{ label.slice(0, 25) }}...
          </span>
        </label>
      </div>
    </div>
    <div class="border-t border-grey-600">
      <div class="flex -mt-1 justify-between">
        <span
          v-for="(tick, i) in ticks"
          :key="tick"
          class="text-xs uppercase font-bold tracking-wide text-grey-600 w-6"
          :class="{
            'text-center': ![0, 100].includes(tick),
            'text-left': tick == 0,
            'text-right': tick == 100
          }"
        >
          <span
            class="border-l border-grey-600 h-2 block w-px"
            :class="{
              'mx-auto': i != 0 && i != ticks.length - 1,
              'mr-auto': i == 0,
              'ml-auto': i == ticks.length - 1
            }"
          ></span>
          <span class="block">{{ tick }}</span>
        </span>
      </div>
    </div>
    <div v-if="error.length" class="text-xs text-negative-700 pt-4">
      {{ error.join(" ") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "InputCategories",
  props: {
    input: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    error: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    categoriesWithValues() {
      return this.categories.filter(({ value }) => value);
    },
    ticks() {
      const allTicks = Array(
        this.isOver100
          ? Math.ceil((Math.ceil(this.total / 10) * 10) / 10) + 1
          : 11
      )
        .fill(0)
        .map((_, i) => i * 10);

      return this.total > 200
        ? [...allTicks.splice(0, 11), "...", ...allTicks.splice(-11)]
        : allTicks;
    },
    total() {
      return Object.values(this.values)
        .map(Number)
        .reduce((sum, v) => (sum += v), 0);
    },
    isOver100() {
      return this.total > 100;
    },
    isUnder100() {
      return this.total < 100;
    },
    categories() {
      return this.fields.map(field => ({
        label: field.label,
        key: field.key,
        value: this.values[field.key]
      }));
    }
  }
};
</script>
